import moment from "moment";
import { compose } from "redux";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

import withUserPerm from "services/withUserPerm";

import DatePicker from "components/DatePicker";

import BudgetSummary from "components/main/BudgetSummary";

import TopKeyword from "components/dashboard/TopKeyword";
import PerformanceSummary from "components/dashboard/PerformanceSummary";
import SpendingAndConversion from "components/dashboard/SpendingAndConversion";

import "styles/Dashboard.css";

import useCurrency from "modules/utils/useCurrency";
import mainSelectors from "modules/main/selectors";
import formatMetricValue from "modules/utils/formatMetricValue";
import formatNumber from "modules/utils/formatNumber";
import campaignAction from "modules/campaign/actions";
import campaignSelectors from "modules/campaign/selectors";
import performanceAction from "modules/performance/actions";
import performanceSelectors from "modules/performance/selectors";
import googleActions from "modules/google/actions";
import googleSelectors from "modules/google/selectors";

const Dashboard = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  let history = useHistory();
  const rmpToken = sessionStorage.getItem("rmp_token");
  const { REACT_APP_RMP_APP_ID } = process.env;
  const yesterdayAsDefault = true;

  const currentAd = useSelector((state) => mainSelectors.currentAd(state));
  const performanceVersus = useSelector((state) => performanceSelectors.performanceVersus(state));
  const listTopKeywordResult = useSelector((state) => campaignSelectors.listTopKeywordResult(state));
  const [selectedViewValue, setSelectedViewValue] = useState();
  const businessInfoResult = useSelector((state) => googleSelectors.getBusinessInfoResult(state));

  useEffect(() => {
    if (businessInfoResult.result !== 0) {
      dispatch(
        googleActions.getBusinessInfo(rmpToken, {
          appId: REACT_APP_RMP_APP_ID,
        }),
      );
    }
  }, [businessInfoResult]);

  useEffect(() => {
    const rmpToken = sessionStorage.getItem("rmp_token");
    console.log("getKeywordList", selectedViewValue);
    if (selectedViewValue && selectedViewValue.value && currentAd && currentAd.ads_account_id) {
      dispatch(
        campaignAction.ListTopKeyword(
          rmpToken,
          currentAd.ads_account_id,
          selectedViewValue.value.start,
          selectedViewValue.value.end,
        ),
      );
      dispatch(
        performanceAction.GetPerformanceVersus(
          currentAd.ads_account_id,
          selectedViewValue.value,
          selectedViewValue.previous,
          selectedViewValue.view,
        ),
      );
    }
  }, [selectedViewValue, currentAd.ads_account_id, dispatch]);

  console.log("performanceVersus", selectedViewValue, performanceVersus);
  let performanceData = performanceVersus.base || {};
  let compareData = performanceVersus.compare || {};

  const isPositiveNumber = (data) => {
    var value = data;
    if (typeof data !== "number") {
      value = data.replace(",", "");
      value = parseFloat(value);
    }
    return value > 0 ? "+" + data : data;
  };

  const performanceInfo = [
    {
      title: t("__clicks"),
      value: formatMetricValue("click", performanceData.click),
      change: !compareData.click
        ? "-"
        : isPositiveNumber(
            formatMetricValue("click", ((performanceData.click - compareData.click) / compareData.click) * 100),
          ) + "%",
      // icon: "icon-click"
    },
    {
      title: t("__impressions"),
      value: formatMetricValue("impr", performanceData.impression),
      change: !compareData.impression
        ? "-"
        : isPositiveNumber(
            formatMetricValue(
              "impr",
              ((performanceData.impression - compareData.impression) / compareData.impression) * 100,
            ),
          ) + "%",
      // icon: "icon-eye"
    },
    {
      title: t("__ctr"),
      value: formatMetricValue("ctr", performanceData.ctr),
      change: !compareData.ctr
        ? "-"
        : isPositiveNumber(formatNumber(((performanceData.ctr - compareData.ctr) / compareData.ctr) * 100)) + "%",
      // icon: "icon-ctr"
    },
    {
      title: t("__avg_cpc"),
      value: formatMetricValue("cpc", performanceData.cpc),
      change: !compareData.cpc
        ? "-"
        : isPositiveNumber(
            formatMetricValue("cpc", ((performanceData.cpc - compareData.cpc) / compareData.cpc) * 100),
          ) + "%",
      // icon: "icon-click-coins",
      unit: useCurrency(),
    },
  ];

  const spendingConversionInfo = [
    {
      title: t("__dashboard_spending"),
      value: formatMetricValue("cost", performanceData.cost),
      unit: useCurrency(),
      change: !compareData.cost
        ? "-"
        : isPositiveNumber(
            formatMetricValue("cost", ((performanceData.cost - compareData.cost) / compareData.cost) * 100),
          ) + "%",
      // icon: "icon-payment"
    },
    {
      title: t("__dashboard_conversion"),
      value: formatMetricValue("conversion", performanceData.conversion),
      change: !compareData.conversion
        ? "-"
        : isPositiveNumber(
            formatMetricValue(
              "conversion",
              ((performanceData.conversion - compareData.conversion) / compareData.conversion) * 100,
            ),
          ) + "%",
      // icon: "icon-retweet"
    },
  ];

  if (!currentAd || currentAd === "") {
    console.log("Change route to no connected ads");
    history.push("/no-connected-ads");
  }

  return (
    <div>
      <BudgetSummary />
      <DatePicker
        key={moment.locale() + " " + yesterdayAsDefault}
        onSelected={setSelectedViewValue}
        defaultIndex={yesterdayAsDefault ? 1 : 0}
      />
      <PerformanceSummary performanceInfo={performanceInfo} />
      <SpendingAndConversion spendingConversionInfo={spendingConversionInfo} />
      <TopKeyword
        date={selectedViewValue ? selectedViewValue.description : ""}
        topKeyword={listTopKeywordResult.data.topKeyword}
      />
    </div>
  );
};

export default compose(withUserPerm())(Dashboard);
